import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { PageHero } from '../layout/PageHero';
import { TopicIndex } from '../layout/TopicIndex';
import { StatementSection } from '../layout/StatementSection';
import { ApplicationPageContent } from '../../data/applicationPages';
import { fadeUp } from '../../utils/motion';
type ApplicationPageProps = {
  content: ApplicationPageContent;
};
export function ApplicationPage({
  content
}: ApplicationPageProps) {
  const {
    highlights
  } = content;
  return <>
      <PageHero eyebrow="Applications" title={content.title} lead={content.lead} body={content.intro} backLink={{
      href: '/solutions',
      label: 'All solutions'
    }} data-id="element-83" data-mp="241xobgf061ep" />

      {highlights && <section className="bg-surface-bg border-b border-line py-14 lg:py-16" data-id="element-84" data-mp="2hv6pwuwplimo">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85" data-mp="2htc6jl135ykp">
            <motion.h2 {...fadeUp} className="text-sm font-medium text-ink-muted mb-6" data-id="element-86" data-mp="2mv1h6zkeca89">
              {highlights.title}
            </motion.h2>
            <motion.ul {...fadeUp} className={`grid grid-cols-1 sm:grid-cols-2 gap-px bg-line border border-line rounded-lg overflow-hidden ${highlights.items.length > 3 ? 'lg:grid-cols-6' : 'md:grid-cols-3'}`} data-id="element-87" data-mp="hhwb070f63s5">
              {highlights.items.map(item => <li key={item.title} className="bg-white p-6" data-id="element-88" data-mp="156fgkes342gj">
                  <p className="font-heading font-bold text-ink-dark leading-snug" data-id="element-89" data-mp="115vj1a3lmwtv">{item.title}</p>
                  {item.description && <p className="mt-2 text-ink-muted leading-relaxed" data-id="element-90" data-mp="wdvqw3trt87u">{item.description}</p>}
                </li>)}
            </motion.ul>
          </div>
        </section>}

      <TopicIndex topics={content.topics} indexLabel="On this page" data-id="element-91" data-mp="1ox10tut3nz6t" />

      <StatementSection title={content.why.title} body={content.why.body} data-id="element-92" data-mp="1k4hlasauqtzd">
        <a href="/solutions" className="mt-8 inline-flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-93" data-mp="2319qf47plshk">
          Explore other solutions
          <ArrowRight size={16} aria-hidden="true" data-id="element-94" data-mp="1u7mvfgbbst9f" />
        </a>
      </StatementSection>
    </>;
}